import React from "react";
import ReactDOM from "react-dom/client";

import "./i18n";

import App from "./App";

import {Provider} from "react-redux";
import {configureStore} from "./redux/store";
import {BrowserRouter} from "react-router-dom";
import * as analytics from "./analytics";

// Google Analytics (GA4) — no-op until REACT_APP_GA_MEASUREMENT_ID is set and
// REACT_APP_ANALYTICS_ENABLED is not false. `app` is passed in rather than baked
// into the module so the same module can be copied to admin-fe/agent-fe verbatim.
analytics.init({app: "supplier"});
// Browser RUM (errors, web vitals, browser spans) → Alloy → Loki/Tempo. Separate
// from GA: that measures product usage, this measures whether the app worked.
// Lazy-imported so a portal with RUM off ships none of the SDK.
import("./analytics/rum").then(m => m.initRum("supplier")).catch(() => {});

if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  console.warn = () => {};
  // Also mute console.error in prod — many call sites dump raw axios errors,
  // Adyen component bodies, or vendor stack traces that may include credentials.
  console.error = () => {};
}

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
    <Provider store={configureStore({})}>
        <React.Fragment>
            <BrowserRouter basename={process.env.PUBLIC_URL}>
                <App/>
            </BrowserRouter>
        </React.Fragment>
    </Provider>
);
